import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; // ak používaš react-router
import { Form, Button, Message, Icon, Input, Container } from "semantic-ui-react";

// Firebase
import { getAuth, verifyPasswordResetCode, confirmPasswordReset, connectAuthEmulator } from "firebase/auth";
import { BackgroundContainer } from "../components/BackgroundContainer";

export default function ResetPasswordPage() {
    const auth = getAuth();
    if (process.env.REACT_APP_USE_EMULATORS === "true") {
        connectAuthEmulator(auth, "http://localhost:9099");
    }

    const [searchParams] = useSearchParams();
    const oobCode = searchParams.get("oobCode");

    const [newPassword, setNewPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    // overenie kódu z URL
    useEffect(() => {
        if (!oobCode) {
            setError("Chýba kód na obnovenie hesla.");
            return;
        }
        verifyPasswordResetCode(auth, oobCode)
            .then(() => {
                setVerified(true);
            })
            .catch(() => {
                setError("Odkaz na reset hesla je neplatný alebo expirovaný.");
            });
    }, [auth, oobCode]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (newPassword.length < 8) {
            setError("Heslo musí mať aspoň 8 znakov.");
            return;
        }
        if (newPassword !== confirm) {
            setError("Heslá sa nezhodujú.");
            return;
        }

        setLoading(true);
        try {
            await confirmPasswordReset(auth, oobCode, newPassword);
            setSuccess("Heslo bolo úspešne zmenené. Teraz sa môžete prihlásiť.");
            setNewPassword("");
            setConfirm("");
        } catch (err) {
            setError("Nepodarilo sa nastaviť nové heslo. Skúste to znova.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <BackgroundContainer>
            <div style={{ maxWidth: 400, width: "100%" }}>
                <h2 style={{ textAlign: "center", marginBottom: "1.5rem", color: "white" }}>
                    Obnova hesla
                </h2>

                {!verified && !error && (
                    <Message info>
                        <Icon name="spinner" loading /> Overujem odkaz...
                    </Message>
                )}

                {error && (
                    <Message negative>
                        <Message.Content>
                            <Icon name="warning circle" /> {error}
                        </Message.Content>
                    </Message>
                )}

                {verified && !success && (
                    <Form onSubmit={handleSubmit} noValidate>
                        <Form.Field required>
                            <label style={{ color: "white" }}>Nové heslo</label>
                            <Input
                                type="password"
                                placeholder="Zadajte nové heslo"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                disabled={loading}
                            />
                        </Form.Field>

                        <Form.Field required>
                            <label style={{ color: "white" }}>Potvrdenie hesla</label>
                            <Input
                                type="password"
                                placeholder="Zopakujte nové heslo"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                disabled={loading}
                            />
                        </Form.Field>

                        <Button
                            type="submit"
                            color="yellow"
                            fluid
                            size="large"
                            loading={loading}
                            disabled={loading}
                            content="Zmeniť heslo"
                        />
                    </Form>
                )}

                {success && (
                    <div>
                        <Message positive>
                            <Message.Content>
                                <Icon name="check circle" /> {success}
                            </Message.Content>
                        </Message>
                        <Container style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button color="yellow" href="/">PREJSŤ NA HLAVNÚ STRÁNKU</Button>
                        </Container>
                    </div>
                )}
            </div>
        </BackgroundContainer>
    );
}